import _ from 'lodash';
import { query } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    feedbackQuestions: [],
    feedbackQuestion: null,
  },
  getters: {
    currentFeedbackQuestion: (state: any) => {
      return state.feedbackQuestion;
    },
  },
  mutations: {
    SET_FEEDBACK_QUESTIONS(state: any, feedbackQuestions: any) {
      state.feedbackQuestions = feedbackQuestions.map(
        (feedbackQuestion: any) => {
          feedbackQuestion.totalResponses =
            feedbackQuestion.feedbackResponsesByFeedbackQuestionId.totalCount;
          return feedbackQuestion;
        },
      );
    },

    SET_CURRENT_FEEDBACK_QUESTION(state: any, feedbackQuestion: any) {
      feedbackQuestion.responses = feedbackQuestion.feedbackResponsesByFeedbackQuestionId.nodes.map(
        (response: any) => {
          response.user = response.userByUserId;
          return response;
        },
      );
      feedbackQuestion.groupedResponses = _.groupBy(
        feedbackQuestion.responses,
        function(response: any) {
          return response.text;
        },
      );
      feedbackQuestion.responses.totalCount =
        feedbackQuestion.feedbackResponsesByFeedbackQuestionId.totalCount;
      state.feedbackQuestion = feedbackQuestion;
    },
  },

  actions: {
    async PULL_FEEDBACK_QUESTION(
      { commit }: any,
      { feedbackQuestionId, currentPage }: any,
    ) {
      let resultsPerPage = 100;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query getFeedbackQuestionByIdDexAdmin($feedbackQuestionId: Int!, $resultsPerPage: Int!, $offset: Int) {
          feedbackQuestionById(id: $feedbackQuestionId) {
            id
            statement
            responseType
            feedbackResponsesByFeedbackQuestionId(
              orderBy: ID_DESC
              first: $resultsPerPage
              offset: $offset
            ) {
              totalCount
              nodes {
                id
                text
                createdAt
                userByUserId {
                  name
                  email
                }
              }
            }
          }
        }`,
        {
          feedbackQuestionId: +feedbackQuestionId,
          resultsPerPage,
          offset,
        },
      );
      let feedbackQuestion = response.data.feedbackQuestionById;
      commit('SET_CURRENT_FEEDBACK_QUESTION', feedbackQuestion);
    },

    async PULL_FEEDBACK_QUESTIONS({ commit }: any, currentPage: number = 0) {
      let resultsPerPage = 100;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query getAllFeedbkacQuestionsDexAdmin($resultsPerPage: Int, $offset: Int){
        allFeedbackQuestions(first: $resultsPerPage, offset: $offset, orderBy: ID_DESC){
          nodes {
            id
            statement
            feedbackResponsesByFeedbackQuestionId{
              totalCount
            }
          }
        }
      }`,
        {
          resultsPerPage,
          offset,
        },
      );
      let feedbackQuestionsNodes = response.data.allFeedbackQuestions;
      if (feedbackQuestionsNodes) {
        commit('SET_FEEDBACK_QUESTIONS', feedbackQuestionsNodes.nodes);
      }
    },
  },
};
